<template>
    <div>
        <sub-menu-faturamento ativo="glosas" v-if="!financeiro" />

        <config-main-title v-if="false">
            Posição de Recebimentos/Glosas
        </config-main-title>

        <div class="card dashcard mb-0">
            <div class="card-body">

                <div class="form-row"> 
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            placeholder="Data de Atendimento"
                            :optionsList="[
                                { id: 'E', search: 'Data de Emissão' },
                                { id: 'N', search: 'Data de Envio' },
                                { id: 'V', search: 'Data de Vencimento' },
                                { id: 'M', search: 'Data de Movimentação' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="tipo_data">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-primary" @click="load(false)" :disabled="$store.state.loading" id="refresh-button">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-user"
                            :placeholder="tipo_data == 'E' 
                                ? 'Responsável pela Emissão...' 
                                : ( ( tipo_data == 'N' || tipo_data == 'V' ) 
                                    ? 'Responsável pelo Envio...'
                                    : ( tipo_data == 'M'
                                        ? 'Responsável pela Movimentação...'
                                        : 'Responsável pela Guia...'
                                    )
                                )"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="usuarios.index" 
                            optionsName="filtro-usuarios"
                            optionsData="id_usuario"
                            :optionsParm="{ where: { fl_ativo: true } }"
                            :optionsSync="false"
                            v-model="filtros.id_usuario" />
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa fa-building fa-fw"
                            placeholder="Unidades..."
                            :optionsList="$util.unidades_com_tags(true, true)"
                            optionsData="id_unidade_operacao"
                            :edicao="!$store.state.user.id_unidade_operacao > 0"
                            v-model="id_unidade_operacao"
                            @input="id_recepcao = ''" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-concierge-bell"
                            type="select"
                            placeholder="Todas as Recepções..."
                            :optionsList="lista_recepcoes"
                            optionsData="id_recepcao"
                            :edicao="id_unidade_operacao > 0"
                            v-model="id_recepcao" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="select"
                            placeholder="Faturas"
                            icon="fa fa-filter"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'R', search: 'Recursos de Glosa' },
                            ]" 
                            optionsData="id"
                            v-model="filtros.tipo" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-credit-card"
                            type="select" 
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            :optionsParm="{ 
                                fatura: true,
                                classes: true 
                            }"
                            optionsName="operadoras-para-fatura-2"
                            placeholder="Todas as Operadoras..."
                            v-model="id_operadora">
                        </az-input>
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="select"
                            placeholder="Contratos..."
                            icon="fa fa-filter"
                            :hli="true"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'PJ', search: 'Contratos PJ' },
                                { id: 'PF', search: 'Contratos PF' },
                            ]" 
                            optionsData="id"
                            v-model="filtros.tipo_contrato" />
                    </div>

                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fas fa-file-powerpoint"
                            type="autocomplete" 
                            optionsMode="aql"
                            optionsData="id_plano"
                            optionsDisplay="st_plano"
                            service="planos.index"
                            :optionsParm="{ id_operadora: id_operadora }"
                            :edicao="id_operadora ? true : false"
                            optionsName="planos"
                            placeholder="Plano..."
                            v-model="filtros.id_plano">
                        </az-input>
                    </div>
                </div>

                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="select"
                            icon="fa-solid fa-filter-circle-dollar"
                            placeholder="Todos"
                            :optionsList="[
                                { id: 'S', search: 'Com Saldo' },
                                { id: 'N', search: 'Sem Saldo' },
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            v-model="filtros.tipo_saldo" />
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input   
                            type="select"
                            placeholder="Reembolsos..."
                            icon="fa fa-filter"
                            :hli="true"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'A', search: 'Apenas Reembolso' },
                                { id: 'E', search: 'Exceto Reembolso' },
                            ]" 
                            optionsData="id"
                            v-model="filtros.tipo_reembolso" />
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-search"
                            v-model="search">
                            <template v-slot:buttonposb>
                                <print-export printid="impressao-posicao" :left="true" :landscape="true" :dados="dadosFormatados">
                                    <template v-slot:outros>
                                        <!-- Sintético/Analítico -->
                                        <div class="btn-group dropleft ml-1">
                                            <button type="button" class="btn btn-outline-secondary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ sintetico ? 'Sintético' : 'Analítico' }}
                                            </button>
                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" href="#" v-if="!sintetico" @click.prevent="sintetico = true">
                                                    <i class="far fa-list-alt mr-2"></i>
                                                    Exportar Sintético
                                                </a>
                                                <a class="dropdown-item" href="#" v-else @click.prevent="sintetico = false">
                                                    <i class="fas fa-list mr-2"></i>
                                                    Exportar Analítico
                                                </a>
                                            </div>
                                        </div>
                                    </template>
                                </print-export>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="checkbox-group"
                            :label="filtros.retroativo ? '' : 'Retroativo'"
                            v-model="filtros.retroativo">
                            <template v-slot:buttonposcb>
                                <input type="date" class="form form-control" v-model="filtros.dt_retroativo" v-if="filtros.retroativo" />
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-2">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'O', search: 'Operadora' },
                                { id: 'U', search: 'Unidade' },
                            ]"
                            optionsData="id"
                            v-model="filtros.campo_base" />
                    </div>
                </div>

            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
                v-if="!dados"
                :icon="firstLoad ? '' : 'fas fa-sync-alt'" 
                :msg="firstLoad ? 'Nenhum item encontrado.' : 'Clique no ícone para atualizar a busca.'"
                :action="firstLoad ? '' : 'Buscar'"
                :method="load"></az-empty-state>

        <div id="impressao-posicao">

            <div class="d-none d-print-block">
                <cabecalho-generico titulo="Posição de Recebimentos/Glosas">
                    <div v-if="dados && dados.periodo">
                        Período: {{ $util.getFormatDate(dados.periodo.inicio) }} 
                        a {{ $util.getFormatDate(dados.periodo.fim) }}

                        <span v-if="dados.periodo.retroativo" class="ml-1">
                            / Retroativo: {{ $util.getFormatDate(dados.periodo.retroativo) }}
                        </span>
                    </div>
                    <div v-if="dados && dados.unidade">
                        {{ dados.unidade.search }}
                    </div>
                </cabecalho-generico>
            </div>

            <div class="small text-muted d-flex justify-content-between d-print-none" v-if="dados">
                <div v-if="dados && dados.periodo">
                    Período: {{ $util.getFormatDate(dados.periodo.inicio) }} 
                    a {{ $util.getFormatDate(dados.periodo.fim) }}

                    <span v-if="dados.periodo.retroativo" class="ml-1">
                        / Retroativo: {{ $util.getFormatDate(dados.periodo.retroativo) }}
                    </span>
                </div>

                <div v-if="dados && dados.unidade">
                    {{ dados.unidade.search }}
                </div>
            </div>

            <table class="table small table-hover bg-white dashcard cabecalho-fixo" v-if="dados">
                <thead>
                    <tr>
                        <th>Descrição</th>
                        <th class="text-right">{{ dados.tipo_data == 'M' ? 'Guias Movimentadas' : ( dados.tipo == 'R' ? 'Recursado' : 'Faturado' ) }}<div class="small">(A)</div></th>
                        <th class="text-right">Recebido <div class="small">(B)</div></th>
                        <th class="text-right">Glosado <div class="small">(C)</div></th>
                        <th class="text-right" v-if="dados.tipo != 'R'">Saldo Fatura <div class="small">(A - B - C)</div></th>
                        <th class="text-right">Em Análise <div class="small">(D)</div></th>
                        <th class="text-right">{{ dados.tipo == 'R' ? 'Definitivo' : 'Acatado' }}<div class="small">(E)</div></th>
                        <template v-if="dados.tipo != 'R'">
                            <th class="text-right">Recursado <div class="small">(F)</div></th>
                            <th class="text-right">Recuperada <div class="small">(G)</div></th>
                            <th class="text-right">Glosado Recurso <div class="small">(H)</div></th>
                            <th class="text-right">Definitiva <div class="small">(I)</div></th>
                            <th class="text-right">Saldo <div class="small text-nowrap">(A - B - C + F - G - I)</div></th>
                        </template>
                        <template v-else>
                            <th class="text-right">Saldo <div class="small text-nowrap">(A - B - C)</div></th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(items, operadora, idx) in tabela">
                        <tr :key="idx">
                            <td>
                                <a class="card-link" data-toggle="collapse" :data-target="'.faturas' + idx" href="#" @click.prevent>
                                    <i class="fa fa-plus-square-o mr-2" aria-hidden="true"></i>
                                </a>
                                {{ operadora }}
                            </td>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'valor')) }}</td>
                            <td class="text-right text-primary">
                                {{ $util.formatMoeda(totalizar(items, 'recebido')) }}
                                <div v-if="totalizar(items, 'a_mais') > 0" class="small text-muted" title="Valor recebido a mais.">
                                    <i class="fa-solid fa-circle-plus mr-1"></i>
                                    {{ $util.formatMoeda(totalizar(items, 'a_mais')) }}
                                </div>
                            </td>
                            <td class="text-right text-danger">
                                <span class="badge badge-secondary" v-if="percentual(totalizar(items, 'glosado'), totalizar(items, 'glosado'))">
                                {{ percentual(totalizar(items, 'valor'), totalizar(items, 'glosado')) }} 
                                </span>
                                {{ $util.formatMoeda(totalizar(items, 'glosado')) }}
                            </td>
                            <td class="text-right" v-if="dados.tipo != 'R'">
                                {{ $util.formatMoeda(totalizar(items, 'saldo_fat')) }}
                            </td>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'em_analise')) }}</td>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'acatado')) }}</td>
                            <template v-if="dados.tipo != 'R'">
                                <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'reapresentado')) }}</td>
                                <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'recuperado')) }}</td>
                                <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'glosado_nr')) }}</td>
                                <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'definitiva')) }}</td>
                            </template>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(items, 'saldo')) }}</td>
                        </tr>

                        <tr v-for="(itemsfatura, fatura, ifx) in faturas(items)" :key="idx + 'fats' + ifx" class="collapse" :class="'faturas' + idx">
                            <td>
                                <a href="#" @click.prevent="$util.abrirFatura(fatura)" class="card-link">
                                    {{ dados.tipo == 'R' ? 'Recurso' : 'Fatura' }}: {{ fatura }}
                                </a>

                                <span class="ml-2">{{ $util.getFormatDate(itemsfatura[0].dt_emissao) }}</span>
                                <span class="ml-2 text-muted text-nowrap" v-if="dados.tipo_data == 'V' && itemsfatura[0].dt_vencimento">
                                    V: {{ $util.getFormatDate(itemsfatura[0].dt_vencimento).substr(0,5) }}
                                </span>
                                <span class="ml-2 text-muted text-nowrap" v-if="dados.tipo_data == 'N' && itemsfatura[0].dt_envio">
                                    Env: {{ $util.getFormatDate(itemsfatura[0].dt_envio).substr(0,5) }}
                                </span>

                                <span class="badge badge-secondary ml-2" title="Recurso do Recurso." v-if="itemsfatura[0].in_numero_reapresentacao > 1">
                                    {{ itemsfatura[0].in_numero_reapresentacao }}
                                </span>

                                <div class="ml-2 text-muted" v-if="itemsfatura[0].st_nota_fiscal">NF: {{ itemsfatura[0].st_nota_fiscal }}</div>
                            </td>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'valor')) }}</td>
                            <td class="text-right" :class="totalizar(itemsfatura, 'recebido') > 0 ? 'text-primary' : 'text-muted'">
                                {{ $util.formatMoeda(totalizar(itemsfatura, 'recebido')) }}
                                <div v-if="totalizar(itemsfatura, 'a_mais') > 0" class="small text-muted" title="Valor recebido a mais.">
                                    <i class="fa-solid fa-circle-plus mr-1"></i>
                                    {{ $util.formatMoeda(totalizar(itemsfatura, 'a_mais')) }}
                                </div>
                            </td> 
                            <td class="text-right" :class="totalizar(itemsfatura, 'glosado') > 0 ? 'text-danger' : 'text-muted'">{{ $util.formatMoeda(totalizar(itemsfatura, 'glosado')) }}</td> 
                            <td class="text-right" v-if="dados.tipo != 'R'">
                                {{ $util.formatMoeda(totalizar(itemsfatura, 'saldo_fat')) }}
                            </td>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'em_analise')) }}</td>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'acatado')) }}</td>
                            <template v-if="dados.tipo != 'R'">
                                <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'reapresentado')) }}</td>
                                <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'recuperado')) }}</td>
                                <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'glosado_nr')) }}</td>
                                <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'definitiva')) }}</td>
                            </template>
                            <td class="text-right">{{ $util.formatMoeda(totalizar(itemsfatura, 'saldo')) }}</td>
                        </tr>
                    </template>
                </tbody>
                <tfoot>
                    <tr>
                        <th>TOTAL</th>
                        <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'valor')) }}</th>
                        <th class="text-right">
                            {{ $util.formatMoeda(totalizar(dados.posicao, 'recebido')) }}
                            <div v-if="totalizar(dados.posicao, 'a_mais') > 0" class="small text-muted" title="Valor recebido a mais.">
                                <i class="fa-solid fa-circle-plus mr-1"></i>
                                {{ $util.formatMoeda(totalizar(dados.posicao, 'a_mais')) }}
                            </div>
                        </th> 
                        <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'glosado')) }}</th> 
                        <th class="text-right" v-if="dados.tipo != 'R'">{{ $util.formatMoeda(totalizar(dados.posicao, 'saldo_fat')) }}</th> 
                        <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'em_analise')) }}</th>
                        <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'acatado')) }}</th>
                        <template v-if="dados.tipo != 'R'">
                            <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'reapresentado')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'recuperado')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'glosado_nr')) }}</th>
                            <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'definitiva')) }}</th>
                        </template>
                        <th class="text-right">{{ $util.formatMoeda(totalizar(dados.posicao, 'saldo')) }}</th>
                    </tr>
                </tfoot>
            </table>

        </div>

        <div class="card-deck mb-3">

            <div class="card card-dash dashcard" style="padding: 0px;" v-if="graf_por_operadora">
                <div class="card-header bg-primary text-white">
                    Distribuição das Glosas
                </div>
                <div class="card-body text-right">
                    <div>
                        <Chart type="pie" :data="graf_por_operadora"  />
                    </div>
                </div>
            </div>

            <div class="card card-dash dashcard" style="padding: 0px;" v-if="graf_por_status">
                <div class="card-header bg-primary text-white">
                    Status das Glosas
                </div>
                <div class="card-body text-right">
                    <div>
                        <Chart type="pie" :data="graf_por_status" />
                    </div>
                </div>
            </div>

        </div>

        <pre v-if="false" class="alert alert-warning">{{ dadosFormatados }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import SubMenuFaturamento from './SubMenuFaturamento.vue';
import ConfigMainTitle from '../../cadastros/shared/ConfigMainTitle.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';

export default {
    data() { 
        return { 
            dados: null, 
            inicio: "",
            fim: "", 
            id_operadora: "", 
            id_unidade_operacao: "", 
            id_recepcao: "", 
            tipo_data: "E", 
            firstLoad: false, 
            canceltoken: null, 
            periodo: "m",
            search: "", 
            filtros: { 
                periodo: "m",
                inicio: "",
                fim: "", 
                tipo_contrato: "", 
                tipo: "", 
                tipo_reembolso: "", 
                tipo_saldo: "", 
                retroativo: false, 
                dt_retroativo: null, 
                campo_base: 'O', 
            },
            sintetico: true
        }
    },

    props: ['financeiro'],

    components: { 
        SubMenuFaturamento,
        ConfigMainTitle, 
        AzEmptyState, 
        AzInput, 
        PrintExport, 
        CabecalhoGenerico, 
        AzPeriodo, 
    },

    computed: { 
        lista_recepcoes: function () { 
            if ( !this.id_unidade_operacao ) { 
                return [];
            }

            let unid = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);

            if ( unid ) { 
                return unid.recepcaos;
            } else { 
                return [];
            }
        },

        dadosFormatados: function () { 
            if ( this.sintetico ) { 
                return _.map(
                    this.tabela,
                    (items, operadora) => { 
                        return {
                            operadora: operadora, 
                            faturado: this.$util.formatMoeda(this.totalizar(items, 'valor')),
                            recebido: this.$util.formatMoeda(this.totalizar(items, 'recebido')),
                            glosado: this.$util.formatMoeda(this.totalizar(items, 'glosado')),
                            em_analise: this.$util.formatMoeda(this.totalizar(items, 'em_analise')),
                            acatado: this.$util.formatMoeda(this.totalizar(items, 'acatado')),
                            recursado: this.$util.formatMoeda(this.totalizar(items, 'reapresentado')),
                            recuperada: this.$util.formatMoeda(this.totalizar(items, 'recuperado')),
                            glosado_recurso: this.$util.formatMoeda(this.totalizar(items, 'glosado_nr')), 
                            definitiva: this.$util.formatMoeda(this.totalizar(items, 'definitiva')), 
                            saldo: this.$util.formatMoeda(this.totalizar(items, 'saldo')),
                        }
                    }
                );
            } 

            if ( !this.dados || !this.dados.posicao )
                return [];

            return _.map(
                    this.dados.posicao,
                    item => { 
                        return {
                            operadora: item.st_operadora, 
                            tipo: this.dados.tipo == 'R' ? 'Recurso' : 'Fatura',
                            numero: item.id_fatura,
                            emissao: this.$util.getFormatDate(item.dt_emissao),
                            envio: this.$util.getFormatDate(item.dt_envio),
                            vencimento: this.$util.getFormatDate(item.dt_vencimento),
                            faturado: this.$util.formatMoeda(item.valor),
                            recebido: this.$util.formatMoeda(item.recebido),
                            glosado: this.$util.formatMoeda(item.glosado),
                            em_analise: this.$util.formatMoeda(item.em_analise),
                            acatado: this.$util.formatMoeda(item.acatado),
                            recursado: this.$util.formatMoeda(item.reapresentado),
                            recuperada: this.$util.formatMoeda(item.recuperado),
                            glosado_recurso: this.$util.formatMoeda(item.glosado_nr), 
                            definitiva: this.$util.formatMoeda(item.definitiva), 
                            saldo: this.$util.formatMoeda(Math.round(item.saldo * 100) / 100), 
                            unidade: item.unidades, 
                            nf: item.st_nota_fiscal, 
                        }
                    }
                );
        },

        tabela: function () { 

            if ( !this.dados )
                return [];

            let lista;

            if ( this.search ) { 
                let reg = this.$util.getregex(this.search);
                lista = this.dados.posicao.filter(item => reg.test(JSON.stringify(item)));
            } else { 
                lista = this.dados.posicao;
            }

            return _.groupBy(lista, 'st_operadora');

        },

        graf_por_operadora: function () { 

            if ( !this.dados )
                return;

            
            
            let dados = _.map(this.tabela, (items, chave) => { 
                return { 
                    label: chave, 
                    valor: this.totalizar(items, 'glosado')
                };
            });

            dados = _.orderBy(dados, 'valor', 'desc');

            let data = _.slice(dados, 0, 4);
            let agrupados = _.slice(dados, 4, dados.length);

            if ( agrupados.length ) { 

                data.push({ 
                    label: 'Outros',
                    valor: agrupados.reduce((total, item) => { 
                        return total + item.valor;
                    }, 0)
                });

            }

            let labels = data.map(item => item.label);
            data = data.map(item => item.valor);

            return { 
                labels: labels,
                datasets: [
					{
						label: 'Glosa',
                        data: data,
                        backgroundColor: [
                            "#264643",
                            "#2A9D8F",
                            "#E9C46A",
                            "#F4A261",
                            "#E76F51",
                        ],
                    },
                ]
            };

        },

        graf_por_status: function () { 

            if ( !this.dados )
                return;

            let labels = ['Em Análise', 'Acatado', 'Recursado'];
            
            let dados = [
                this.totalizar(this.dados.posicao, 'em_analise'),
                this.totalizar(this.dados.posicao, 'acatado'),
                this.totalizar(this.dados.posicao, 'reapresentado'),
            ]
            
            return { 
                labels: labels,
                datasets: [
					{
						label: 'Glosa',
                        data: dados,
                        backgroundColor: [
                            "#264643",
                            "#2A9D8F",
                            "#E9C46A",
                            "#F4A261",
                            "#E76F51",
                        ],
                    },
                ]
            };

        },
    },

    methods: { 
        formatMoedaGrafico(value) { 
            let show = this.$util.formatMoeda(value);
            return show.substr(0,show.length - 3);
        },

        faturas (lista) { 
            return _.groupBy(lista, 'id_fatura');
        },

        percentual (total, parte) { 
            if ( total )
                return Math.round( ( parte / total ) * 100 ) + '%';
        },
        totalizar (items, campo) { 
            if ( !items )
                return 0;

            return items.filter(item => item[campo])
                .reduce((total, item) => total + parseFloat(item[campo]), 0);
        },

        load() { 

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            $('.collapse').collapse('hide');

            /*
            inicio: this.inicio,
            fim: this.fim,
            periodo: this.periodo,
            */

            this.$util.load(this, { 
                service: 'faturas',
                func: 'glosas',
                redir_api: true, 
                parms: { 
                    tipo_data: this.tipo_data,
                    id_operadora: this.id_operadora,
                    id_unidade_operacao: this.id_unidade_operacao,
                    id_recepcao: this.id_recepcao, 
                    ...this.filtros,
                },
                canceltoken: this.canceltoken.token,
                callback: () => { 
                    this.firstLoad = true;
                }
            });
        },

        ajustar_fim() { 
            if ( !this.firstLoad )
                return;

            if ( this.inicio )
                this.fim = this.inicio;
        },
    },

    beforeMount () { 

        this.inicio = moment().subtract(30, "days").format('YYYY-MM-DD');
        this.fim = moment().format('YYYY-MM-DD');

    },

    mounted() { 
        //this.load();
        //this.firstLoad = true;
        
        if ( this.financeiro ) { 
            this.$store.commit("setBreadcrumb", [
                { name: "Financeiro", path: "/financeiro/lancamento" },
                { name: "Posição de Recebimentos/Glosas", path: "/financeiro/glosas" }
            ]);
        } else { 
            this.$store.commit('setBreadcrumb', 
                [
                    { name: "Faturamento", path: "/faturamento/visao"},
                    { name: "Posição de Recebimentos/Glosas", path: "/financeiro/glosas" }
                ]
            );
        }
    }
}
</script>